module.exports = require("./sd-Deva.js");